import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface NoShowTransientStayDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  bookingNumber: string
  onConfirm: () => void
  isPending: boolean
}

export function NoShowTransientStayDialog({
  open,
  onOpenChange,
  bookingNumber,
  onConfirm,
  isPending,
}: NoShowTransientStayDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Mark as No-Show</AlertDialogTitle>
          <AlertDialogDescription>
            Mark booking{' '}
            <span className="font-mono font-semibold">{bookingNumber}</span> as
            no-show? The guest did not arrive for their reservation.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isPending}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isPending ? 'Processing…' : 'Confirm No-Show'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
